import { Badge, BadgeProps } from '@chakra-ui/react';
import { FC } from 'react';

export type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

export interface SaveStatusBadgeProps extends Omit<BadgeProps, 'children'> {
  status: SaveStatus;
  showOnIdle?: boolean;
}

/**
 * Badge component for displaying save status of auto-saved content.
 * Shows visual feedback for saving, saved, and error states.
 */
export const SaveStatusBadge: FC<SaveStatusBadgeProps> = ({
  status,
  showOnIdle = false,
  ...badgeProps
}) => {
  // Don't render anything for idle state unless explicitly requested
  if (status === 'idle' && !showOnIdle) {
    return null;
  }

  switch (status) {
    case 'saving':
      return (
        <Badge colorScheme="yellow" variant="subtle" {...badgeProps}>
          Saving...
        </Badge>
      );
    case 'saved':
      return (
        <Badge colorScheme="green" variant="subtle" {...badgeProps}>
          Saved
        </Badge>
      );
    case 'error':
      return (
        <Badge colorScheme="red" variant="subtle" {...badgeProps}>
          Save Failed
        </Badge>
      );
    case 'idle':
      return (
        <Badge colorScheme="gray" variant="subtle" {...badgeProps}>
          Ready
        </Badge>
      );
    default:
      return null;
  }
};
